export function getCookie(name: string) {
  var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
  if (arr !== null) return unescape(arr[2]);
  return null;
}

export function delCookie(cookieName: string) {
  var ex = new Date();
  ex.setTime(ex.getTime() - 1);
  const cval = getCookie(cookieName);
  if (cval) {
    document.cookie =
      cookieName +
      '=' +
      cval +
      ';path=/;domain=.sinoclick.com;expires=' +
      ex.toUTCString();
    document.cookie =
      cookieName +
      '=' +
      cval +
      ';path=/;domain=localhost;expires=' +
      ex.toUTCString();
  }
}

export function setCookie(name: string, value: string, hours: number) {
  var expires = '';
  if (hours) {
    var date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
